import { serverUrl } from './serverConfig'
export const signInUserWithEmailPasswordRequest = async(email, password) => {
    try {
        const user = {
            "identity": "user.aca.login",
            "username": email,
            "password": password,
        }
        const authResponse = await fetch(
            serverUrl, {
                // mode: 'no-cors',
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(user)
            }
        )
        return await authResponse.json();
    } catch (errors) {
        return errors
    }
}